const POSTS_LOOP_FRAGMENT = `
    id
    title
    slug
    excerpt
    date
    featuredImage {
        node {
            mediaDetails {
                sizes(include: [LARGE]) {
                    name
                    sourceUrl
                    width
                    mimeType
                }
            }
            mediaItemUrl
            srcSet
        }
    }
`;

export default POSTS_LOOP_FRAGMENT;